import React, { useState }  from "react";
import {  Dialog, Button} from "@mui/material";
import UploadIcon from '@mui/icons-material/Upload';
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import logo from "../assets/xflix-logo.png";
import UploadForm from "./UploadForm"

const Header=({children , fetchVideos, genres, contentRatings })=>{
  const [isModalOpen, setIsModalOpen] = useState(false);

 const handleOpen = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };
return(
  <>
  <Dialog
      open={isModalOpen}
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
  >
   <Grid container className="dialog">
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
          <Grid item xs={10}>
            <h3 className="form-header">Upload Video</h3>
         </Grid> 
         <Grid item xs={2}>
             <IconButton
                aria-label="close"
                className="close-button"
                onClick={handleClose}
              >
               <CloseIcon />
             </IconButton>
         </Grid>
      </Box>
        <Grid item xs={12}>
          <UploadForm
            onClose={handleClose}
            fetchVideos={fetchVideos}
            genres={genres}
            contentRatings={contentRatings}
          />
        </Grid>
     </Grid>
  </Dialog>
  <Box display="flex" 
     flexWrap="wrap"
     justifyContent="space-between" 
     alignItems="center" 
     sx={{paddingX:"1rem"}}
   >
    <Box className="header-title" marginTop="1rem">
      <Link to="/">
        <img className="xflix-icon" src={logo} alt="XFlix-icon"/>
      </Link>   
    </Box>
    <Box className="search-box" marginTop="1rem">
      {children}
    </Box>
    <Box className="header-action" marginTop="1rem">
      <Button
        id="upload-btn"
        className="primary-button"
        startIcon={<UploadIcon />}
        variant="contained"
        onClick={handleOpen}
      >
        Upload
      </Button>
    </Box>  
  </Box>
  </>

)
}

export default Header;